var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        staticClass: "chiped-input",
        class: _vm.dense ? "grv-input-dense" : "grv-input",
        attrs: {
          "menu-props": { contentClass: "grv-menu" },
          rules: _vm.rules,
          value: _vm.value,
          clearable: "",
          items: _vm.items,
          loading: _vm.loading,
          "item-text": "1",
          "item-value": "0",
          name: _vm.param.name,
          "search-input": _vm.search,
          readonly: _vm.readonly,
          "auto-select-first": "",
          dense: _vm.dense,
          "no-filter": "",
          "hide-no-data": "",
          chips: "",
          "small-chips": _vm.dense,
          "deletable-chips": !_vm.readonly,
          placeholder: _vm.items.length
            ? "Selectionner un patron"
            : "Rechercher un Patron"
        },
        on: {
          "update:error": function($event) {
            _vm.errored = $event
          },
          "update:searchInput": function($event) {
            _vm.search = $event
          },
          "update:search-input": function($event) {
            _vm.search = $event
          },
          change: function($event) {
            return _vm.$emit("update:value", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.param } })]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param, errored: _vm.errored } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d98b3dc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d98b3dc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/patronid.vue
// module id = null
// module chunks = 